import * as React from "react";

// Components
import { Navbar, LightNavbar, Footer } from "../index";

const Index = ({ children }) => {
  const [posiiton, setPosiiton] = React.useState({
    x: 0,
    y: 0,
  });
  const url = typeof window !== "undefined" ? window.location.pathname : "/";
  const elementRef = React.useRef(null);
  const [height, setHeight] = React.useState(0);

  const setFooterHeight = () => {
    if (elementRef.current) {
      setHeight(elementRef.current.getBoundingClientRect().height);
    }
  };

  React.useEffect(() => {
    setFooterHeight();
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setFooterHeight();
    };

    window.addEventListener("resize", handleResize, { passive: true });

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    const buttons = document.querySelectorAll("button");
    const inputs = document.querySelectorAll("input");
    const textareas = document.querySelectorAll("textarea");
    const links = document.querySelectorAll("a");
    const customState = document.querySelectorAll(".hovered-cursor");
    const hoveredStates = [
      ...buttons,
      ...links,
      ...inputs,
      ...textareas,
      ...customState,
    ];
    const cursor = document.querySelector(".inner-cursor");

    document.addEventListener("mousemove", (event) => {
      setPosiiton({
        x: event.clientX,
        y: event.clientY,
      });
    });

    hoveredStates.forEach((state) => {
      state.addEventListener("mouseover", () => {
        cursor.classList.add("grow");
      });
      state.addEventListener("mouseleave", () => {
        cursor.classList.remove("grow");
      });
    });
  }, [posiiton]);

  return (
    <React.Fragment>
      <div
        className="inner-cursor bg-blue d-none d-xl-block"
        style={{
          transform: `translate3d(${posiiton.x}px, ${posiiton.y}px, 0px)`,
        }}
      />
      <div
        className="outer-cursor d-none d-xl-block"
        style={{
          transform: `translate3d(${posiiton.x}px, ${posiiton.y}px, 0px)`,
        }}
      />
      {url === "/" ? (
        <Navbar />
      ) : url.includes("/services") ? (
        <Navbar />
      ) : (
        <LightNavbar />
      )}
      <main
        className="overflow-x-hidden main"
        style={{
          marginBottom: `${height}px`,
        }}
      >
        {children}
      </main>

      <Footer footerRef={elementRef} />
    </React.Fragment>
  );
};

export default Index;
